/**
 * "82 of 85 notifications failed to deliver in the last 24 h" — over the Alert pages, so a broken
 * channel is seen where rules are edited, not only on the Delivery log. Dismissable per session.
 */
import { ArrowRightIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';

export interface DeliveryFailBannerProps {
  failed: number;
  total: number;
  onOpenLog: () => void;
  onDismiss: () => void;
}

export default function DeliveryFailBanner({ failed, total, onOpenLog, onDismiss }: DeliveryFailBannerProps) {
  if (!failed) return null;
  return (
    <div role="alert" className="flex flex-wrap items-center gap-3 rounded-2xl border border-red-500/40 bg-red-500/10 px-4 py-3 text-[14px] text-foreground">
      <ExclamationTriangleIcon className="h-5 w-5 shrink-0 text-red-600" />
      <p className="min-w-[14rem] flex-1">
        <b className="font-semibold text-red-600">{failed} of {total}</b> notifications failed to deliver in the last 24 h. Rules are firing, but people may not be receiving them.
      </p>
      <button type="button" onClick={onOpenLog} className="inline-flex items-center gap-1 text-[14px] font-semibold text-red-600 hover:underline">
        Open delivery log <ArrowRightIcon className="h-4 w-4" />
      </button>
      <button type="button" onClick={onDismiss} className="rounded-lg p-1 text-muted-foreground hover:bg-card hover:text-foreground" aria-label="Dismiss">
        <XMarkIcon className="h-4 w-4" />
      </button>
    </div>
  );
}
